import React, { useState } from 'react';
import './InfoPanel.css';

function InfoPanel() {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <>
      <button className="info-toggle" onClick={() => setIsOpen(!isOpen)}>
       i
      </button>
      <div className={`info-panel ${isOpen ? 'open' : ''}`}>
  <div className="info-panel-content">
    <h3 className="info-panel-title">🎬 QReel</h3>

    <div className="info-section">
      <h5>🔍 Problem</h5>
      <p>
        Movie enthusiasts and casual viewers struggle with:
      </p>
      <ul>
        <li>Finding films based on vague memories</li>
        <li>Discovering similar movies they might enjoy</li>
        <li>Accessing comprehensive film information in one place</li>
      </ul>
    </div>

    <div className="info-section">
      <h5>💡 Solution</h5>
      <p>
        QReel combines quantum search algorithms with AI to:
      </p>
      <ul>
        <li>Search by partial titles, plots, or descriptions</li>
        <li>Understand natural language queries</li>
        <li>Provide instant access to cast, soundtracks, and box office data</li>
        <li>Find truly similar movies based on multiple factors</li>
      </ul>
    </div>

    <div className="info-section">
      <h5>📊 Benefits</h5>
      <ul>
        <li>Faster search results with quantum acceleration</li>
        <li>More accurate movie recommendations</li>
        <li>Comprehensive film details in a single interface</li>
        <li>Intuitive experience for film buffs and casual viewers alike</li>
      </ul>
    </div>

    <div className="info-section">
      <h5>🎯 Who It's For</h5>
      <p>Movie Fans • Film Students • Cinephiles • Casual Viewers • Content Creators</p>
    </div>
    
    {isOpen && (
      <button 
        className="info-panel-close" 
        onClick={() => setIsOpen(false)}
      >
        ×
      </button>
    )}
  </div>
</div>
    </>
  );
}

export default InfoPanel;